import React, { useState, useRef, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import axios from "axios";
import PatientMiddleware from './PatientMiddleware';
import { IoWarning } from "react-icons/io5";
import { MdBloodtype } from "react-icons/md";
import { RiExpandHeightFill } from "react-icons/ri";
import { GiWeight } from "react-icons/gi";
import { useNavigate } from 'react-router-dom';
import { Modal, Label } from 'flowbite-react';
import { FaFileImage } from "react-icons/fa6";
import { TiTick } from "react-icons/ti";
import DataTable from 'react-data-table-component';

//images
import profilebg from '../img/PatientsProfileBg.gif';
import userIcon from "../img/user.png";
import toast, { Toaster } from 'react-hot-toast';
import { jwtDecode } from 'jwt-decode';
import chart1 from '../assest/charts/11920-cholesterol-chart.jpg';
import chart2 from '../assest/charts/Pillar-BPNumbers_ENG.png';
import chart3 from '../assest/charts/download.png';
import chart4 from '../assest/charts/understanding-blood-pressure-normal-ranges-for-men-and-women-and-tips-for-maintaining-healthy-levelsl-ArtemisHospitals.png';

const Patients = () => {
  const navigation = useNavigate();
  const [healthDetails, setHealthDetails] = useState(false);
  const [profileDetails, setProfileDetails] = useState(null);
  const [reports, setReports] = useState([]);
  const [addDetails, setAddDetails] = useState(false);
  const [categories, setCategories] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [previousDoctors, setPreviousDoctors] = useState([]);
  const [reportFetch, setReportFetch] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploader, setUploader] = useState(true);
  const [reportDetails, setReportDetails] = useState({
    reportDate: '',
    fbs: '',
    ppbs: '',
    rbs: '',
    bmi: '',
    weight: '',
    height: '',
    hba1c: '',
    bp: '',
    tc: '',
    tg: '',
    ldl: '',
    hdl: '',
    urine: '',
    creatinine: '',
    urea: '',
    sgpt: '',
    sgot: '',
    creativeProtein: ''
  });
  const [reportData, setReportData] = useState({
    title: '',
    reportDate: '',
    doctor: '',
    category: '',
    image: null,
  });
  const [formData, setFormData] = useState({
    blood: profileDetails?.blood || '',
    height: profileDetails?.height || '',
    weight: profileDetails?.weight || '',
  });
  const [addReports, setAddReports] = useState(false);
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('patientAuthToken');

    try {
      const response = await axios.patch('https://backend.amarasinghemedicare.com/patient/update-health', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        toast.success("Updated success!");
        fetchUserData();
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Error in updating details");
    }
    setHealthDetails(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setReportData({ ...reportData, image: file });
    }
    setUploader(!uploader);
  };

  const fetchReports = async () => {
    try {
      const token = localStorage.getItem('patientAuthToken');

      const res = await axios.get('https://backend.amarasinghemedicare.com/patient/report-fetch', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setReportFetch(res.data);
    } catch (error) {
      console.error('Failed to fetch reports:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddReport = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('patientAuthToken');

    if (!reportData.title || !reportData.doctor || !reportData.category || !reportData.image) {
      toast.error("Please fill all fields");
      return;
    }

    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!allowedTypes.includes(reportData.image.type)) {
      toast.error("Only JPG, JPEG, and PNG formats are allowed");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('title', reportData.title);
    formDataToSend.append('reportDate', reportData.reportDate);
    formDataToSend.append('doctor', reportData.doctor);
    formDataToSend.append('category', reportData.category);
    formDataToSend.append('image', reportData.image);

    try {
      const response = await axios.post('https://backend.amarasinghemedicare.com/patient/report', formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        toast.success("Report added successfully");
        setAddReports(false);
        setReportData({
          title: '',
          reportDate: '',
          doctor: '',
          category: '',
          image: null,
        });
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
      }
    } catch (error) {
      console.error('Error uploading report:', error);
      toast.error("Error uploading report");
    }
  };

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setReportData({ ...reportData, [name]: value });
  };

  const fetchPreviousDoctors = async () => {
    const token = localStorage.getItem('patientAuthToken');

    try {
      const response = await axios.get('https://backend.amarasinghemedicare.com/patient/patient/appointments', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        setPreviousDoctors(response.data.appointments || []);
      }
    } catch (error) {
      console.error("Error fetching previous doctors:", error);
      setPreviousDoctors([]); // ensure it's always an array
    }
  };

  const handleAddDetails = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('patientAuthToken');

      const response = await axios.post('https://backend.amarasinghemedicare.com/patient/report-data', reportDetails, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response.status === 200) {
        toast.success('Medical report added successfully!');
        setReportData({
          reportDate: '',
          fbs: '',
          ppbs: '',
          rbs: '',
          bmi: '',
          weight: '',
          height: '',
          hba1c: '',
          bp: '',
          tc: '',
          tg: '',
          ldl: '',
          hdl: '',
          urine: '',
          creatinine: '',
          urea: '',
          sgpt: '',
          sgot: '',
          creativeProtein: ''
        });
        handleClose(); // Close modal
      } else {
        toast.error('Something went wrong while adding the report.');
      }
    } catch (error) {
      console.error('Error submitting report:', error);
      alert('Failed to submit medical report.');
    }
  };

  const handleDetailsChanges = (e) => {
    const { name, value } = e.target;
    setReportDetails(prev => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    fetchPreviousDoctors();
    fetchReports();
  }, []);

  useEffect(() => {
    const fetchReports = async () => {
      const token = localStorage.getItem('patientAuthToken');

      try {
        const response = await axios.get('https://backend.amarasinghemedicare.com/patient/reports-display', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          setReports(response.data.reports);
        }
      } catch (error) {
        console.error("Error fetching reports:", error);
      }
    };

    fetchReports();
  }, []);

  useEffect(() => {
    axios.get('https://backend.amarasinghemedicare.com/category/categories')
      .then((response) => setCategories(response.data))
      .catch((error) => console.error('Error fetching categories:', error));
  }, []);

  useEffect(() => {
    axios.get('https://backend.amarasinghemedicare.com/doctors/details')
      .then((response) => setDoctors(response.data))
      .catch((error) => console.error('Error fetching categories:', error));
  }, []);

  const fetchUserData = async () => {
    const token = localStorage.getItem('patientAuthToken');

    if (!token) {
      navigation('/patientLogin');
      return;
    }

    try {
      const decodedToken = jwtDecode(token);

      const currentTime = Date.now() / 1000;
      if (decodedToken.exp < currentTime) {
        localStorage.clear();
        navigation('/patientLogin');
        return;
      }

      const timeUntilExpiration = (decodedToken.exp - currentTime) * 1000;
      const logoutTimer = setTimeout(() => {
        localStorage.clear();
        navigation('/patientLogin');
        toast.error("Session expired. Please log in again.", { position: "top-center" });
      }, timeUntilExpiration);

      axios.get('https://backend.amarasinghemedicare.com/patient/my-profile', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          setProfileDetails(response.data);
          setFormData({
            blood: response.data.blood,
            height: response.data.height,
            weight: response.data.weight
          });
        })
        .catch((error) => {
          console.error('Error in fetching data :', error);
        })

      return () => clearTimeout(logoutTimer);

    } catch (error) {
      toast.error("Something went wrong!");
      localStorage.clear();
      navigation("/patientLogin");
    }
  };

  const handleClose = () => {
    setAddReports(false);
    setAddDetails(false);
    setUploader(true);
    setReportData({
      title: '',
      reportDate: '',
      doctor: '',
      category: '',
      image: null,
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  }

  useEffect(() => {
    fetchUserData();
  }, [])

  const addDetailsFunction = () => {
    setAddDetails(true);
  }

  const calculateAge = (dob) => {
    if (!dob) return "N/A"; // without date of birth display N/A
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    // Subtract the age, if the national date is not the same as the current date
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  };

  const columns = [
    { name: 'දිනය (Date)', selector: row => row.reportdate, sortable: true },
    { name: 'FBS', selector: row => row.fbs },
    { name: 'PPBS', selector: row => row.ppbs },
    { name: 'RBS', selector: row => row.rbs },
    { name: 'බර (Kg)', selector: row => row.weight },
    { name: 'උස (Cm)', selector: row => row.height },
    { name: 'BMI', selector: row => row.bmi },
    { name: 'HbA1c', selector: row => row.hba1c },
    {
      name: 'Lipid Profile - TC',
      selector: row => row.tc,
    },
    {
      name: 'Lipid Profile - TG',
      selector: row => row.tg,
    },
    {
      name: 'Lipid Profile - LDL',
      selector: row => row.ldl,
    },
    {
      name: 'Lipid Profile - HDL',
      selector: row => row.hdl,
    },
    { name: 'Urine Microalbumin', selector: row => row.urine },
    { name: 'Serum Creatinine', selector: row => row.creatinine },
    { name: 'Urea', selector: row => row.urea },
    { name: 'SGPT', selector: row => row.sgpt },
    { name: 'SGOT', selector: row => row.sgot },
    { name: 'BP', selector: row => row.bp },
    { name: 'Creative Protein', selector: row => row.creativeprotein },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#202643',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '12px',
      },
    },
    cells: {
      style: {
        fontSize: '12px',
      },
    },
  };

  return (
    <PatientMiddleware>
      <div>
        <Toaster />
        <Header />
        <div className="grid w-full h-auto grid-cols-1 mt-2 md:grid-cols-7">
          {/* Left Side */}
          <div className="col-span-1 md:col-span-2 border-2 border-[#98DED9] m-2 md:ml-3 md:mt-3 rounded-2xl">
            {/* profile */}
            {profileDetails && (
              <div className="bg-violet-50 w-full h-auto border-b-2 border-b-[#98DED9] rounded-2xl">
                <img src={profilebg}
                  alt="profile_background" className="w-full h-[229px] object-cover rounded-2xl" />
                <div className="pb-2">
                  <img src={profileDetails.profileImage ? `http://localhost:8081${profileDetails.profileImage}` : userIcon}
                    alt="Profile_image" className="object-cover w-32 h-32 mx-auto -mt-16 rounded-full shadow-lg" />
                  <h2 className="uppercase text-center mt-2 font-bold text-[25px] text-[#161D6F]">
                    {profileDetails.firstName} {profileDetails.lastName}
                  </h2>
                  <h4 className="uppercase text-center -mt-2 font-bold text-[20px] text-[#7465B9]">{calculateAge(profileDetails.dob)} years old</h4>
                </div>

              </div>)}

            {profileDetails && (
              <div className="p-2 mt-4">

                <div className="flex md:flex-col justify-around md:justify-center mt-3 text-center xl:flex-row xl:gap-20 bg-[#ececec] p-2 rounded-lg shadow-lg">

                  <div className='flex flex-col items-center justify-center'>
                    <MdBloodtype className='text-[42px] text-[#990e0e] mb-1' />
                    <p className="text-[18px] text-[#8895A8] font-normal m-0">Blood</p>
                    <p className="text-black text-[18px] font-medium">{profileDetails.blood ? (profileDetails.blood) : ("--")}</p>
                  </div>

                  <div className='flex flex-col items-center justify-center'>
                    <RiExpandHeightFill className='text-[42px] text-[#1d4b8f] mb-1' />
                    <p className="text-[18px] text-[#8895A8] font-normal m-0">Height</p>
                    <p className="text-black text-[18px] font-medium">{profileDetails.height ? (profileDetails.height + " cm") : ("--")}</p>
                  </div>

                  <div className='flex flex-col items-center justify-center'>
                    <GiWeight className='text-[42px] text-[#40a820] mb-1' />
                    <p className="text-[18px] text-[#8895A8] font-normal m-0">Weight</p>
                    <p className="text-black text-[18px] font-medium">{profileDetails.weight ? (profileDetails.weight + " kg") : ("--")}</p>
                  </div>
                </div>

                <button onClick={() => setHealthDetails(true)} className="mt-2 text-[16px] text-white uppercase font-semibold text-left bg-[#97CE4F] p-2 rounded-lg transform transition-transform duration-300 hover:scale-105">Update Health Details</button>
              </div>
            )}

            <div className="mt-5 m-2">
              <h1 className="text-[20px] font-light">Previous Doctors</h1>

              {Array.isArray(previousDoctors) && previousDoctors.length === 0 ? (
                <p className='text-sm text-gray-500 mt-2'>No previous appointments found.</p>
              ) : (
                previousDoctors.map((doc, index) => (
                  <div
                    key={index}
                    className='flex bg-gray-200 p-2 rounded-md mt-2 gap-3 items-center justify-center'
                  >
                    <div className='w-[20%]'>
                      <img
                        className='rounded-full border-[1px] border-black w-full aspect-square object-cover'
                        src={
                          doc?.profileImage
                            ? `https://backend.amarasinghemedicare.com/${doc.profileImage.replace(/\\/g, '/')}`
                            : require('../assest/images/Doctor.png') // Or use a public path if needed
                        } alt=""
                      />
                    </div>

                    <div className='w-[80%]'>
                      <h1 className='font-medium'>{doc.doctorName}</h1>
                      <h2 className='text-sm font-extralight mt-1'>
                        {doc.specialization} | <span className='text-red'>{new Date(doc.appointmentDate).toISOString().split('T')[0]}</span>
                      </h2>
                    </div>
                  </div>
                ))
              )
              }
            </div>

            <div className="mt-5 m-2">
              <h1 className="text-[20px] font-light">Medical Reports</h1>

              {reports.map((report, index) => (
                <a
                  key={index}
                  href={`https://backend.amarasinghemedicare.com/Upload/Patient/${report.image}`}
                  target="_blank"
                  rel="noreferrer"
                  className="block"
                >
                  <div className='flex bg-gray-200 p-2 rounded-md mt-2 gap-3 items-center justify-center hover:bg-gray-300 cursor-pointer'>
                    <div className='w-[20%]'>
                      <FaFileImage className='text-4xl ml-2 text-blue' />
                    </div>

                    <div className='w-[80%]'>
                      <h1>{report.title}</h1>
                      <h2 className='text-sm font-extralight mt-1'>
                        {report.doctor} | <span className='text-red'>{new Date(report.reportDate).toISOString().split('T')[0]}</span>
                      </h2>
                    </div>
                  </div>
                </a>
              ))}


              <div>
                <button
                  onClick={() => setAddReports(true)}
                  className="mt-2 text-[16px] text-white uppercase font-semibold text-left bg-fontDark p-2 rounded-lg transform transition-transform duration-300 hover:scale-105"
                >
                  Add new report
                </button>
              </div>
            </div>

          </div>

          {/* Right Side */}
          <div className="col-span-1 md:col-span-5 border-2 m-2 md:ml-1 md:mt-3 shadow-2xl rounded-lg">
            <div className="shadow-lg">
              <div className="p-1 border-red border-[3px] m-2 rounded-md flex items-center justify-center bg-[#df707a7c]">
                <IoWarning className='text-[85px] text-rose-600' />
                <h1 className="text-[18px] font-bold mx-7 my-4">ඔබගේ දියවැඩියා තත්වය සම්බන්ධයෙන් නිරතුරුව අවධියෙන් සිටීම දියවැඩියාව නිසා හටගන්නා සංකූලතා අවම කරයි. ඒ සඳහා පහත කාල වකවානු තුලදී අදාල පරීක්ෂණ සිදුකරගැනීම අප විසින් අනුමත කරමු.</h1>
              </div>

              <div className="mt-2">
                <h1 className="font-bold text-[22px] bg-[#97CE4F] p-3 text-center w-fit border-y-2 border-r-2 border-black rounded-r-lg">සතිපතා පරීක්ෂණ</h1>
                <p className="text-[16px] font-semibold mx-5 rounded-md my-4 shadow-2xl p-3">නිවසේදී අහඹු රුධිර සීනි පරීක්ෂාව - මේ සඳහා ඔබගේ රුධිර සීනි පරීක්ෂණය භාවිතා කල හැකිය.</p>
              </div>

              <div className="mt-2">
                <h1 className="font-bold text-[22px] bg-[#97CE4F] p-3 text-center w-fit border-y-2 border-r-2 border-black rounded-r-lg">මාසික පරීක්ෂණ</h1>
                <p className="text-[16px] font-semibold mx-5 rounded-md my-4 shadow-2xl p-3">ඔබගේ FBS පරීක්ෂාව / PPBS පරීක්ෂාව හෝ RBS පරීක්ෂාව පයශීෂණාගාරයකින් කර ගත යුතුය. FBS පරීක්ෂාව පැය 08ක කාලයක් නිරාහාරව සිටිය යුතුය. නිරාහාර කාලාන්තරය තුළ වතුර වීදුරුවක් තොලගැම අනුමත කරමු.</p>
              </div>

              <div className="mt-2 mb-4">
                <h1 className="font-bold text-[22px] bg-[#97CE4F] p-3 text-center w-fit border-y-2 border-r-2 border-black rounded-r-lg">මාස 03කට වරක්</h1>
                <div className='flex flex-col gap-1 shadow-2xl p-3 rounded-md mx-5 my-4'>
                  <p className="text-[16px] font-semibold">HbA1c පරීක්ෂාව (මෙම පරීක්ෂාව සඳහා නිරාහාරව සිට පැමිණීම අවශ්‍ය නොවේ).</p>
                  <p className="text-[16px] font-semibold">මුත්‍රා පරීක්ෂාව (Urea).</p>
                  <p className="text-[16px] font-semibold">සීරම් ක්‍රියැටින් පරීක්ෂාව (Serum Creatinine).</p>
                  <p className="text-[16px] font-semibold">පාද සත්කාරය හා අවශ්‍ය ඕනෑම පරීක්ෂාවක් සිදු කල යුතුය.</p>
                </div>

              </div>

              <div className="mb-4">
                <h1 className="font-bold text-[22px] bg-[#97CE4F] p-3 text-center w-fit border-y-2 border-r-2 border-black rounded-r-lg">මාස 03කට වරක්</h1>
                <div className='flex flex-col gap-1 shadow-2xl p-3 rounded-md mx-5 my-4'>
                  <p className="text-[16px] font-semibold">පුර්ණ අක්ෂි පරීක්ෂාව.</p>
                  <p className="text-[16px] font-semibold">වකුගඩු පරීක්ෂාව.</p>
                  <p className="text-[16px] font-semibold">සම්පූර්ණ මුත්‍රා පරීක්ෂාව.</p>
                  <p className="text-[16px] font-semibold">X- කිරණ පරීක්ෂාව කොළොස්ට්‍රෝල් පරීක්ෂාව (මේ සඳහා පැය 12ක කාලයක් නිරාහාරව පැමිණිය යුතුය).</p>
                  <p className="text-[16px] font-semibold">සම්පූර්ණ පාද පරීක්ෂාව.</p>
                  <p className="text-[16px] font-semibold">දන්ත පරීක්ෂාව.</p>
                </div>
              </div>
              <div className="mt-2 mb-4">
                <h1 className="font-bold text-[22px] bg-[#97CE4F] p-3 text-center m-0">ඔබ විසින් පහත ඉලක්කයන් සපුරා ගැනීම සඳහා වෙහෙස විය යුතුය.</h1>
                <div className="grid w-full h-auto grid-cols-1 p-0 m-0 md:grid-cols-5">
                  {/* Left column */}
                  <div className="col-span-2 lg:border-r-2 lg:border-r-[#98DED9] p-4">
                    <table className="text-[14px] w-full mt-3">
                      <tbody>
                        <tr>
                          <td className="py-2 font-semibold">FBS</td>
                          <td className="font-medium text-center ">-</td>
                          <td className="text-left font-medium text-[#777f86]">&nbsp;&nbsp;70 - 110 mg/dl</td>
                        </tr>
                        <tr>
                          <td className="py-2 font-semibold">PPBS</td>
                          <td className="font-medium text-center">-</td>
                          <td className="text-left font-medium text-[#777f86]">&nbsp;&nbsp;100 - 140 mg/dl</td>
                        </tr>
                        <tr>
                          <td className="py-2 font-semibold">Total Cholesterol</td>
                          <td className="font-medium text-center">-</td>
                          <td className="text-left font-medium text-[#777f86]">&nbsp;&nbsp;&lt;200 mg/dl</td>
                        </tr>
                        <tr>
                          <td className="py-2 font-semibold">Triglyceride</td>
                          <td className="font-medium text-center">-</td>
                          <td className="text-left font-medium text-[#777f86]">&nbsp;&nbsp;&lt;150 mg/dl</td>
                        </tr>
                        <tr>
                          <td className="flex justify-start py-2 font-semibold">HDL Cholesterol</td>
                          <td className="font-medium text-justify">-</td>
                          <td className="text-left font-medium text-[#777f86]">
                            &nbsp;&nbsp;&gt;40 mg/dl<br />
                            &nbsp;&nbsp;&gt;50 mg/dl
                          </td>
                        </tr>
                        <tr>
                          <td className="py-2 font-semibold">LDL Cholesterol</td>
                          <td className="font-medium text-center">-</td>
                          <td className="text-left font-medium text-[#777f86]">&nbsp;&nbsp;&lt;80 mg/dl</td>
                        </tr>
                        <tr>
                          <td className="py-2 font-semibold">Blood Urea</td>
                          <td className="font-medium text-center">-</td>
                          <td className="text-left font-medium text-[#777f86]">&nbsp;&nbsp;&lt;40 mg/dl</td>
                        </tr>
                        <tr>
                          <td className="py-2 font-semibold">Serum Creatinine</td>
                          <td className="font-medium text-center">-</td>
                          <td className="text-left font-medium text-[#777f86]">&nbsp;&nbsp;&lt;1.2 mg/dl</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Right column */}
                  <div className="col-span-1 p-4 md:col-span-3">
                    <table className="w-full text-[14px] mt-3">
                      <h1 className='font-semibold mb-2'>HbA1c value chart</h1>
                      <tbody>
                        <tr className='bg-[#1a922a3f]'>
                          <td className="py-2 pr-4 text-left font-bold text-base text-[#1a922a]">&lt;5.6%</td>
                          <td className="py-2  text-left font-bold text-base text-[#1a922a]">Normal Value</td>
                          <td className="py-2 text-left font-bold text-base text-[#1a922a]">අනුමත අගය</td>
                        </tr>
                        <tr className="text-[#61d13e] bg-[#60d13e54]">
                          <td className="py-2 pr-4 font-bold text-base text-left">5.6% - 7%</td>
                          <td className="py-2 font-bold text-base text-left">Good Control</td>
                          <td className="py-2 font-bold text-base text-left">පාලනය හොඳයි</td>
                        </tr>
                        <tr className="text-[#dac827] bg-[#dac8274d]">
                          <td className="py-2 pr-4 font-bold text-base text-left">7.0% - 8%</td>
                          <td className="py-2 font-bold text-base text-left">Fair Control</td>
                          <td className="py-2 font-bold text-base text-left">පාලනය සාමන්‍යයි</td>
                        </tr>
                        <tr className="text-[#ce6868] bg-[#ce686856]">
                          <td className="py-2 pr-4 font-bold text-base text-left">8.0% - 10%</td>
                          <td className="py-2 font-bold text-base text-left">Unsatisfactory Control</td>
                          <td className="py-2 font-bold text-base text-left">පාලනය සෑහීමට පත් නොවේ</td>
                        </tr>
                        <tr className="text-[#df2a2a] bg-[#df2a2a5b]">
                          <td className="py-2 pr-4 font-bold text-base text-left">&gt;10%</td>
                          <td className="py-2 font-bold text-base text-left">Poor Control</td>
                          <td className="py-2 font-bold text-base text-left">පාලනය අධිකවම අඩුයි</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <h3 className="font-bold text-[18px] bg-[#97CE4F] p-3 text-center m-0">ඉහත අගයන් ඔබගේ මඟපෙන්වීම සඳහා සකසන ලද සාමන්‍ය අගයන් ය.</h3>

                <div className='flex justify-center items-center gap-2'>
                  <div className='w-[50%]'>
                    <img src={chart1} alt="" />
                  </div>

                  <div className='w-[50%]'>
                    <img src={chart2} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Lower Side */}
          <div className="m-2 overflow-x-auto md:col-span-7 md:mx-5 md:my-3">

            <div className="mt-6">

              <div className='flex items-center justify-start gap-2 mb-3'>
                <h2 className="text-lg font-semibold">Medical Report Summary</h2>
                <button onClick={addDetailsFunction} className="flex items-center justify-center align-middle font-semibold gap-1 p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 bg-green text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">Add Details</button>
              </div>

              <DataTable
                columns={columns}
                data={reportFetch}
                customStyles={customStyles}
                pagination
                fixedHeader
                fixedHeaderScrollHeight="400px"
                highlightOnHover
                responsive
              />
            </div>

          </div>
        </div>

        <Modal size='md' show={healthDetails} onClose={() => setHealthDetails(false)} popup>
          <Modal.Header />
          <Modal.Body>
            <form className="w-full space-y-4'" onSubmit={handleSubmit}>
              <div>
                <h3 className="text-xl font-medium text-gray-900 mb-4">Update <span className='text-red'>Health</span> Details</h3>
              </div>

              <div className="mt-4">
                <div className='flex items-center gap-4'>
                  <label htmlFor="email" className="w-40 text-[#261C53] text-[15px]">
                    Blood:
                  </label>
                  <input
                    type="text"
                    id="blood"
                    name="blood"
                    value={formData.blood}
                    onChange={handleChange}
                    className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>
              </div>

              <div className="mt-4">
                <div className='flex items-center gap-4'>
                  <label htmlFor="contactNumber" className="w-40 text-[#261C53] text-[15px]">
                    Height in cm:
                  </label>
                  <input
                    type="number"
                    id="height"
                    name="height"
                    value={formData.height}
                    onChange={handleChange}
                    className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>
              </div>

              <div className="mt-4">
                <div className='flex items-center gap-4'>
                  <label htmlFor="contactNumber" className="w-40 text-[#261C53] text-[15px]">
                    Weight in kg:
                  </label>
                  <input
                    type="number"
                    id="weight"
                    name="weight"
                    value={formData.weight}
                    onChange={handleChange}
                    className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>
              </div>

              <div className='flex justify-end items-center h-10 mt-5 gap-3'>
                <button
                  className="text-[16px] text-white uppercase font-semibold text-left bg-red p-2 rounded-lg transform transition-transform duration-300 hover:scale-105"
                >
                  close
                </button>
                <button
                  type="submit"
                  className="text-[16px] text-white uppercase font-semibold text-left bg-[#97CE4F] p-2 rounded-lg transform transition-transform duration-300 hover:scale-105"
                >
                  Update
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        <Modal size='md' show={addReports} onClose={handleClose} popup>
          <Modal.Header />
          <Modal.Body>
            <form onSubmit={handleAddReport} className="w-full space-y-4">
              <div>
                <h3 className="text-xl font-medium text-gray-900 mb-4">Add <span className='text-red'>Medical</span> Report</h3>
              </div>

              <div className="mt-4">
                <div className='flex items-center gap-4'>
                  <label htmlFor="reportTitle" className="w-40 text-[#261C53] text-[15px]">
                    Report Title:
                  </label>
                  <input
                    type="text"
                    id="title"
                    name="title"
                    onChange={handleChanges}
                    value={reportData.title}
                    className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>
              </div>

              <div className="mt-4">
                <div className='flex items-center gap-4'>
                  <label htmlFor="reportTitle" className="w-40 text-[#261C53] text-[15px]">
                    Select Doctor:
                  </label>
                  <select name="doctor" id="doctor" value={reportData.doctor} onChange={handleChanges}
                    className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 w-full"
                  >
                    <option value="" disabled selected className="text-gray-700">
                      Select doctor
                    </option>
                    {doctors.map((doctor) => (
                      <option key={doctor.fullName} value={doctor.fullName} className="text-black bg-white">
                        {doctor.fullName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mt-4">
                <div className='flex items-center gap-4'>
                  <label htmlFor="reportTitle" className="w-40 text-[#261C53] text-[15px]">
                    Select Category:
                  </label>
                  <select name="category" id="category" value={reportData.category} onChange={handleChanges}
                    className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 w-full"
                  >
                    <option value="" disabled selected className="text-gray-700">
                      Select category
                    </option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.eng_name} className="text-black bg-white">
                        {category.id}. {category.eng_name} - {category.sin_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mt-4">
                <div className='flex items-center gap-4'>
                  <label htmlFor="reportTitle" className="w-40 text-[#261C53] text-[15px]">
                    Report Date:
                  </label>
                  <input
                    type="date"
                    id="reportDate"
                    name="reportDate"
                    value={reportData.reportDate}
                    onChange={handleChanges}
                    className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>
              </div>

              <div className="mt-4">
                <label htmlFor="" className="w-40 text-[#261C53] text-[15px]">Upload Category image</label>
                {uploader ? (
                  <div className="flex w-full items-center justify-center mt-2" id='fileUploadArea'>
                    <Label
                      htmlFor="dropzone-file"
                      className="flex h-32 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-[#d8dad8]"
                    >
                      <div className="flex flex-col items-center justify-center pb-6 pt-5">
                        <svg
                          className="mb-4 h-8 w-8 text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 20 16"
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                          />
                        </svg>
                        <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                          <span className="font-semibold">Click to upload</span> or drag and drop
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">SVG, PNG, JPG (MAX. 800x400px)</p>
                      </div>
                      <input
                        type="file"
                        name="image"
                        id="dropzone-file"
                        onChange={handleFileChange}
                        ref={fileInputRef}
                        className="hidden"
                      />
                    </Label>
                  </div>
                ) : (
                  <div className="flex w-full items-center justify-center mt-2 h-32 bg-[#d8dad8] rounded-lg flex-row" id='fileUploaded'>
                    <TiTick className='text-5xl text-[#97CE4F]' />
                    <h1 className='text-sm text-gray-500 dark:text-gray-400 font-semibold'>File Updated</h1>
                  </div>
                )}
              </div>

              <div className='flex justify-end items-center h-10 mt-5 gap-3'>
                <button
                  onClick={handleClose}
                  className="text-[16px] text-white uppercase font-semibold text-left bg-red p-2 rounded-lg transform transition-transform duration-300 hover:scale-105"
                >
                  close
                </button>
                <button
                  type="submit"
                  className="text-[16px] text-white uppercase font-semibold text-left bg-[#97CE4F] p-2 rounded-lg transform transition-transform duration-300 hover:scale-105"
                >
                  Add Report
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>

        <Modal size="md" show={addDetails} onClose={handleClose} popup>
          <Modal.Header />
          <Modal.Body>
            <form onSubmit={handleAddDetails} className="w-full space-y-4">
              <h3 className="text-2xl font-semibold text-gray-900 mb-6">
                Add <span className='text-red'>Medical Report</span>
              </h3>

              {/* Report Date */}
              <div className="mt-4">
                <div className='flex items-center gap-4'>
                  <label htmlFor="reportTitle" className="w-40 text-[#261C53] text-[15px]">
                    Report Date:
                  </label>
                  <input
                    type="date"
                    id="reportDate"
                    name="reportDate"
                    onChange={handleDetailsChanges}
                    required
                    className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  />
                </div>
              </div>

              {/* Row 1 */}
              <h1 className="text-[#261C53] text-[15px]">
                FBS | PPBS | RBS | BMI Details
              </h1>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

                <input type="text" value={reportDetails.fbs} name="fbs" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='FBS' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.ppbs} name="ppbs" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='PPBS' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.rbs} name="rbs" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='RBS' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.bmi} name="bmi" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='BMI' onChange={handleDetailsChanges} />
              </div>

              {/* Row 2 */}
              <h1 className="text-[#261C53] text-[15px]">
                Weight | Height | hba1c | Blood Pressure
              </h1>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <input type="text" value={reportDetails.weight} name="weight" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='Weight (kg)' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.height} name="height" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='Height (cm)' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.hba1c} name="hba1c" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='hba1c' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.bp} name="bp" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='bp' onChange={handleDetailsChanges} />
              </div>

              {/* Lipid Profile */}
              <h1 className="text-[#261C53] text-[15px]">
                Lipid Profile Details
              </h1>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <input type="text" value={reportDetails.tc} name="tc" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='TC' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.tg} name="tg" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='TG' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.ldl} name="ldl" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='LDL' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.hdl} name="hdl" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='HDL' onChange={handleDetailsChanges} />
              </div>

              {/* Remaining Fields */}
              <h1 className="text-[#261C53] text-[15px]">
                Urine Microalbumin | Serum Creatinine | Urea | SGPT | SGOT | Creative Protein
              </h1>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <input type="text" value={reportDetails.urine} name="urine" label="Urine Microalbumin" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='UM' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.creatinine} name="creatinine" label="Serum Creatinine" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='SC' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.urea} name="urea" label="Urea" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='Urea' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.sgpt} name="sgpt" label="SGPT" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='SGPT' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.sgot} name="sgot" label="SGOT" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='SGOT' onChange={handleDetailsChanges} />
                <input type="text" value={reportDetails.creativeProtein} name="creativeProtein" label="Creative Protein" className="flex-1 p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder='CP' onChange={handleDetailsChanges} />
              </div>

              {/* Buttons */}
              <div className="flex justify-end items-center h-10 mt-5 gap-3">
                <button
                  onClick={handleClose}
                  type="button"
                  className="text-[16px] text-white uppercase font-semibold bg-red p-2 rounded-lg hover:scale-105 transition-transform duration-300"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="text-[16px] text-white uppercase font-semibold bg-[#97CE4F] p-2 rounded-lg hover:scale-105 transition-transform duration-300"
                >
                  Add Report Details
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>

      </div></PatientMiddleware>
  );
};

export default Patients;